export default {
    bind (el, binding, vnode) {
    },
    inserted (el, binding, vnode) {
    },
    update (el, binding, vnode) {
    },
    componentUpdated (el, binding, vnode) {
        el.disabled = binding.value !== 'edit'
//        if (binding.value === 'edit') {
//            el.removeAttribute('disabled')
//        } else {
//            el.setAttribute('disabled', true)
//        }
    },
    unbind (el, binding, vnode) {
    },
}

